import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, Heart, Stethoscope, Landmark, GraduationCap, Award, ExternalLink, Instagram, Globe } from 'lucide-react';
interface AllyLink {
  type: 'web' | 'instagram';
  label: string;
  href: string;
}
interface Ally {
  category: string;
  name: string;
  role: string;
  description: string;
  links?: AllyLink[];
}
const allies: Ally[] = [{
  category: 'NEURODESARROLLO',
  name: 'Developing Brains',
  role: 'Liudmila Guas & Dr. Mauricio Chinchilla',
  description: 'Organización especializada en neurología y neurodesarrollo infantil. 3 años de colaboración continua.',
  links: [{
    type: 'web',
    label: 'Sitio web',
    href: 'https://www.thedevelopingbrains.com/en'
  }, {
    type: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/thedevelopingbrains?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=='
  }]
}, {
  category: 'PEDIATRÍA',
  name: 'Dr. Andrés Marcano',
  role: 'Pediatra especializado',
  description: 'Especialista en autismo y TDAH, referente en la comunidad latina de Florida',
  links: [{
    type: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/mipediatratea?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D'
  }]
}, {
  category: 'PSICOLOGÍA',
  name: 'Lorena Jiménez',
  role: 'Famikids',
  description: 'Psicología infantil y familiar para el acompañamiento integral del núcleo familiar',
  links: [{
    type: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/famikids?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D'
  }]
}, {
  category: 'PSICOLOGÍA',
  name: 'Mirna Cobo',
  role: 'Psicóloga Clínica y Escolar',
  description: 'Psicóloga clínica y escolar dedicada al bienestar emocional y al desarrollo integral de niños y familias.'
}, {
  category: 'EDUCACIÓN',
  name: 'Dra. Lenys González-Valles',
  role: 'Gastroenteróloga · Autismo y Salud Intestinal',
  description: 'Gastroenteróloga experta en autismo y salud intestinal. Autora del primer estudio latinoamericano sobre salud intestinal en niños con autismo. Su colaboración con la fundación es a través de charlas y conferencias educativas para padres. En alianza con Nutritea_ve y la Lic. Lizmary García.',
  links: [{
    type: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/drlenysgonzal'
  }]
}];
export function PartnershipsSection() {
  const partnerTypes = [{
    icon: Building2,
    title: 'Empresas'
  }, {
    icon: Heart,
    title: 'Fundaciones'
  }, {
    icon: Stethoscope,
    title: 'Profesionales de Salud'
  }, {
    icon: Landmark,
    title: 'Entidades Gubernamentales'
  }, {
    icon: GraduationCap,
    title: 'Instituciones Educativas'
  }, {
    icon: Award,
    title: 'Marcas Comprometidas'
  }];
  return <section id="alianzas" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-213" data-mp="2jngvy21hdlq4">
      <div className="max-w-6xl mx-auto" data-id="element-214" data-mp="2oiw88pjub9kf">
        <h2 style={{
        fontSize: '32px',
        fontWeight: 800,
        color: '#1a1a1a',
        textAlign: 'center',
        marginBottom: '12px'
      }} data-id="element-215" data-mp="2tjk4bpmxegli">
          Nuestros Aliados
        </h2>
        <p style={{
        fontSize: '15px',
        color: '#666',
        textAlign: 'center',
        marginBottom: '40px'
      }} data-id="element-216" data-mp="32inrp5t4li5t">
          Trabajamos con empresas, fundaciones y profesionales comprometidos con
          la familia
        </p>
        <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '12px',
        maxWidth: '700px',
        margin: '0 auto 40px'
      }} data-id="element-217" data-mp="3hafukibqh3qn">
          {partnerTypes.map(({
          icon: Icon,
          title
        }) => <span key={title} className="mp-ally-pill" style={{
          background: '#f0fae8',
          border: '1.5px solid #c8eaa0',
          color: '#2d5a1b',
          padding: '10px 20px',
          borderRadius: '30px',
          fontSize: '14px',
          fontWeight: 600,
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px'
        }} data-id="element-218" data-mp="huceqf4k0qiv">
              <Icon size={15} color="currentColor" data-id="element-219" data-mp="cxlxhoh0jovv" />
              {title}
            </span>)}
        </div>
        <Link to="/quiero-ser-aliado" className="mp-ally-cta" style={{
        background: '#7DC920',
        color: 'white',
        padding: '14px 32px',
        borderRadius: '10px',
        fontWeight: 700,
        fontSize: '15px',
        border: 'none',
        display: 'block',
        width: 'fit-content',
        margin: '0 auto',
        textDecoration: 'none'
      }} data-id="element-220" data-mp="7z2b5myicb2z">
          Quiero ser Aliado →
        </Link>
        <h3 className="mp-allies-title" style={{
        fontSize: '28px',
        fontWeight: 800,
        textAlign: 'center',
        color: '#1a1a1a',
        margin: '48px 0 32px'
      }} data-id="element-221" data-mp="1mu0uhyy74s48">
          Nuestra Red de Aliados
        </h3>
        <div className="mp-allies-grid" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '20px',
        maxWidth: '960px',
        margin: '0 auto'
      }} data-id="element-222" data-mp="2fkiv8tbg6heh">
          {allies.map(ally => <div key={ally.name} className="mp-ally-card" style={{
          background: 'white',
          borderRadius: '14px',
          padding: '24px 20px',
          boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
          border: '1px solid #f0f0f0',
          position: 'relative'
        }} data-id="element-223" data-mp="2tgo08bnrtfia">
              {ally.links && <span aria-hidden="true" style={{
            position: 'absolute',
            top: '12px',
            right: '12px'
          }} data-id="element-224" data-mp="2u5y2wnpfwimo">
                  {ally.links[0].type === 'instagram' ? <Instagram size={12} color="#7DC920" data-id="element-225" data-mp="2fg8xggabdsgl" /> : <ExternalLink size={12} color="#7DC920" data-id="element-226" data-mp="2ahfmauii2djl" />}
                </span>}
              <span style={{
            background: '#e8f5e0',
            color: '#2d5a1b',
            fontSize: '10px',
            fontWeight: 700,
            letterSpacing: '2px',
            padding: '3px 10px',
            borderRadius: '20px',
            display: 'inline-block',
            marginBottom: '12px'
          }} data-id="element-227" data-mp="26gc6g80gchid">
                {ally.category}
              </span>
              <p style={{
            fontSize: '16px',
            fontWeight: 700,
            color: '#1a1a1a',
            marginBottom: '4px'
          }} data-id="element-228" data-mp="uyhm3bkr9af7">
                {ally.name}
              </p>
              <p style={{
            fontSize: '13px',
            color: '#7DC920',
            fontWeight: 600,
            marginBottom: '8px'
          }} data-id="element-229" data-mp="2a2akz0u1a8m">
                {ally.role}
              </p>
              <p style={{
            fontSize: '13px',
            color: '#666',
            lineHeight: 1.5
          }} data-id="element-230" data-mp="3aokr7p4u9y3u">
                {ally.description}
              </p>
              {ally.links && <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '12px',
            marginTop: '12px',
            paddingTop: '12px',
            borderTop: '1px solid #f0f0f0'
          }} data-id="element-231" data-mp="242jonf2i5r11">
                  {ally.links.map(link => <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer" style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '4px',
              fontSize: '12px',
              color: '#7DC920',
              fontWeight: 600,
              textDecoration: 'none'
            }} data-id="element-232" data-mp="2rxw3vbq9k3nq">
                      {link.type === 'instagram' ? <Instagram size={12} data-id="element-233" data-mp="3uc9y10kt7he8" /> : <Globe size={12} data-id="element-234" data-mp="3ua5y0tq172j8" />}
                      {link.label}
                    </a>)}
                </div>}
            </div>)}
        </div>
        <p style={{
        fontSize: '12px',
        color: '#999',
        textAlign: 'center',
        marginTop: '24px',
        fontStyle: 'italic'
      }} data-id="element-235" data-mp="36n7l2614ecq2">
          * Todos los aliados han dado autorización para aparecer en este sitio
        </p>

        <div className="mp-pineyro-card" style={{
        background: '#f0fae8',
        border: '1.5px solid #7DC920',
        borderRadius: '14px',
        padding: '24px 32px',
        display: 'flex',
        alignItems: 'center',
        gap: '24px',
        maxWidth: '960px',
        margin: '20px auto 0'
      }} data-id="element-236" data-mp="31nl5vr1qemem">
          <div className="flex items-center justify-center" style={{
          width: '56px',
          height: '56px',
          background: '#2d5a1b',
          borderRadius: '50%',
          flexShrink: 0
        }} data-id="element-237" data-mp="22hqj7vpxlsfa">
            <Award size={24} color="white" data-id="element-238" data-mp="1tiwussmr88ct" />
          </div>
          <div data-id="element-239" data-mp="2h7xw7vx66j8l">
            <p style={{
            fontSize: '18px',
            fontWeight: 700,
            color: '#1a1a1a'
          }} data-id="element-240" data-mp="2h7g2p71w6j4d">
              Concejal Rafael Pineyro
            </p>
            <p style={{
            color: '#7DC920',
            fontWeight: 600,
            fontSize: '14px',
            margin: '4px 0'
          }} data-id="element-241" data-mp="27f0is471bkgu">
              Ciudad de Doral — Impacto Social e Institucional
            </p>
            <p style={{
            fontSize: '14px',
            color: '#444'
          }} data-id="element-242" data-mp="34xjwkmpa34i6">
              Respaldo institucional de la Ciudad de Doral para los programas y
              eventos de la fundación
            </p>
          </div>
        </div>

      </div>
    </section>;
}